import React, { useState, useEffect } from "react";

import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { AudienceSegment } from "@/types";
import { toIconLabel } from "@/utils";

interface MindsetMiniCardProps {
  segment: AudienceSegment;
  segmentNum: number;
  onSelect: (segment: AudienceSegment) => void;
  selected: boolean;
}

const MindsetSegmentCard: React.FC<MindsetMiniCardProps> = ({ segment, segmentNum, onSelect, selected = false }) => {

  // Image urls
  const [src, setSrc] = useState<string>(`https://sc-opendata.s3.eu-west-1.amazonaws.com/mindset_images/${toIconLabel(segment.segment_name)}.png`);
  const defaultImage = "https://sc-opendata.s3.eu-west-1.amazonaws.com/mindset_images/default.png";

  const theme = useTheme();

  useEffect(() => {
    setSrc(`https://sc-opendata.s3.eu-west-1.amazonaws.com/mindset_images/${toIconLabel(segment.segment_name)}.png`)
  }, [segment])

  return (
    <Card
      sx={{
        position: "relative",
        height: "100px",
        width: "150px",
        borderRadius: 2,
        overflow: "hidden",
        cursor: "pointer",
        border: 1,
        borderColor: selected ? theme.palette.primary.main : theme.palette.divider,
      }}
      onClick={() => onSelect(segment)}
    >
      <CardActionArea
        sx={{
          height: "100%",
          position: "relative",
          "&:hover img": {
            filter: "grayscale(0%)"
          }
        }}
      >
        {/* Background Image */}
        <CardMedia
          component="img"
          height="200"
          image={src}
          onError={() => setSrc(defaultImage)}
          alt={segment.segment_name}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: selected ? undefined : "grayscale(100%)",
          }}
        />

        {/* Dark Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(rgba(0,0,0,0.0) 0%, rgba(0,0,0,1.0) 90%)",
            zIndex: 1,
          }}
        />

        {/* Content Overlay */}
        <CardContent
          sx={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            p: 1,
            color: "white",
          }}
        >
          <Box>
            <Typography variant="body2" sx={{ color: selected ? theme.palette.primary.main : undefined}}>
              {segment.segment_name}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default MindsetSegmentCard;
